/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import { formatAndShortCurrency } from "../../../../app/modules/Common/utils";

export function ListStatsWidget({ className, name, data, constant, currency, section, formatCurrencyValue }) {
  const renderCurrencyAmount = (amount) =>
    formatCurrencyValue ? formatCurrencyValue(amount) : currency + formatAndShortCurrency(amount).toUpperCase();

  return (
    <div className={`card card-custom ${className}`}>
      {/* Head */}
      <table style={{ padding: "50px" }}>
        <thead style={{ boxShadow: "0 1px 4px rgba(0, 0, 0, 0.1)" }}>
          <tr>
            <th
              style={{
                padding: "15px",
                fontWeight: "600",
                fontSize: "1.375rem",
                color: "rgb(234, 30, 81)",
              }}
            >
              {name}
            </th>
            <th style={{ fontWeight: "600", fontSize: "16px" }}>Qty</th>
            <th style={{ fontWeight: "600", fontSize: "16px" }}>Amount</th>
          </tr>
        </thead>
        <tbody style={{ paddingTop: "5px", marginTop: "10px" }}>
          {/* Body */}
          {Object.keys({ ...data.by_status }).map((key) => {
            return Object.keys(constant).map((constKey, index) => {
              return Number(constant[constKey].value) === Number(key) ? (
                <tr key={Number(key)}>
                  <td
                    style={{
                      paddingLeft: "20px",
                      fontWeight: "500",
                      fontSize: "1.12rem",
                      paddingBottom: "1.25rem",
                      paddingTop: index === 0 ? "10px" : "",
                    }}
                  >
                    <span
                      style={{
                        verticalAlign: "bottom",
                        marginRight: "13px",
                        borderRadius: "5px",
                        display: "inline-block",
                        alignSelf: "stretch",
                        width: "4px",
                        height: "25px",
                        backgroundColor: constant[constKey].color,
                      }}
                    ></span>
                    {constKey === "RETURNED" && section === "sale" ? constant[constKey].dashboardType : constant[constKey].type}
                  </td>
                  <td style={{ fontSize: "1.08rem", fontWeight: "500" }}>{data.by_status[key].qty}</td>
                  <td style={{ fontSize: "1.08rem", fontWeight: "500" }}>{renderCurrencyAmount(data.by_status[key].amount)}</td>
                </tr>
              ) : (
                ""
              );
            });
          })}
        </tbody>
        <tbody>
          <tr>
            <td>
              <hr style={{ marginTop: "-10px", paddingBottom: "20px" }} />{" "}
            </td>
            <th
              style={{
                fontSize: "16px",
                fontWeight: "600",
                paddingBottom: "20px",
              }}
            >
              <hr />
              {data.total_qty ? data.total_qty : 0}
            </th>
            <th
              style={{
                fontSize: "16px",
                fontWeight: "600",
                paddingBottom: "20px",
                color: "rgb(234, 30, 81)",
              }}
            >
              <hr />
              {renderCurrencyAmount(data.total_amount)}
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
